import { createSelector } from 'reselect';
import * as subscriptionStatus from '../constants/subscription';
import {PERMISSIONS_CREATOR, PERMISSIONS_DESIGNER} from "../constants/user";
import user from "../reducers/user";

const getUser = state => state.user;

export const isEmailVerified = createSelector(
    [getUser],
    (user) => {
        if (!user.userData) {
            return false;
        }

        return !!user.userData.email_verified_at;
    }
);

export const getEmail = createSelector(
    [getUser],
    (user) => {
        if (!user.userData) {
            return '';
        }
        return user.userData.email;
    }
);

export const isVerified = createSelector(
    [getUser],
    (user) => {
        return !!(user.userData && user.userData.email_verified_at);
    }
);

export const getSubscriptionInfo = createSelector(
    [getUser],
    (user) => {
        /*if (!user.userData || !user.userData.subscription_status) {
            return null;
        }*/

        let diffDays = 0;
        let isExpired = false;

        if (user.userData.stripe_current_period_end) {
            const periodEnd = user.userData.cancel_at ? user.userData.cancel_at : user.userData.stripe_current_period_end;
            const today = new Date();
            const endDate = new Date(periodEnd);

            let diffTime = endDate - today;

            if (diffTime < 0) {
                diffTime = 0;
                isExpired = true;
            }
            const day = 1000 * 60 * 60 * 24;

            diffDays = Math.floor(diffTime / day);
        }

        let subscriptionStatusText = '';

        if (user.userData.cancel_at) {
            subscriptionStatusText = 'Canceled';
        } else if (
            !_isSubscriptionAccessible(user.userData) &&
            _isTrialWasStarted(user.userData)) {
            subscriptionStatusText = 'Subscription inactive';
        } else {
            switch (user.userData.subscription_status) {
                case subscriptionStatus.STATUS_CANCELED:
                    subscriptionStatusText = 'Subscription inactive';
                    break;
                case subscriptionStatus.STATUS_INCOMPLETE:
                case subscriptionStatus.STATUS_INCOMPLETE_EXPIRED:
                case subscriptionStatus.STATUS_PAST_DUE:
                case subscriptionStatus.STATUS_UNPAID:
                    subscriptionStatusText = 'Billing issues';
                    break;
                case subscriptionStatus.STATUS_ACTIVE:
                    subscriptionStatusText = 'Subscription active';
                    break;
                case subscriptionStatus.STATUS_TRIALING:
                    subscriptionStatusText = 'Free trial';
                    break;
                default:
                    subscriptionStatusText = 'Free trial not started';
                    break;
            }
        }

        return {
            isCancelled: !!user.userData.cancel_at,
            isSubscription: !!user.userData.subscription_status,
            subscriptionStatusText: subscriptionStatusText,
            subscriptionStatus: user.userData.subscription_status,
            stripeSubscriptionId: user.userData.stripe_subscription_id,
            stripeCurrentPeriodStart: user.userData.stripe_current_period_start,
            stripeCurrentPeriodEnd: user.userData.stripe_current_period_end,
            stripeTrialStart: user.userData.stripe_trial_start,
            stripeTrialEnd: user.userData.stripe_trial_end,
            stripeCanceledAt: user.userData.canceled_at,
            stripeCancelAt: user.userData.cancel_at,
            daysLeft: diffDays,
            isExpired: isExpired,
        };
    }
);

export const isHasSubscription = createSelector(
    [getUser],
    (user) => {
        return _isHasSubscription(user);
    }
);

export const _isHasSubscription = (user) => !!(user.userData && user.userData.subscription_status);

export const isSubscriptionActive = createSelector(
    [getUser],
    (user) => {
        return _isSubscriptionActive(user.userData);
    }
);
export const isSubscriptionAccessible = createSelector(
    [getUser],
    (user) => {
        return _isSubscriptionAccessible(user.userData);
    }
);

export const getIsTrialWasStarted = createSelector(
    [getUser],
    (user) => {
        if (!user.userData) {
            return false;
        }

        return _isTrialWasStarted(user.userData);
    }
);
export const isSubscriptionUnpaid = createSelector(
    [getUser],
    (user) => {
        return _isSubscriptionUnpaid(user.userData);
    }
);

export const isSubscriptionPastDue = createSelector(
    [getUser],
    (user) => {
        return _isSubscriptionPastDue(user.userData);
    }
);

export const isStaffAccess = createSelector(
    [getUser],
    (user) => {
        if (!user.userData) {
            return false;
        }

        return user.userData.permissions === PERMISSIONS_CREATOR || user.userData.permissions === PERMISSIONS_DESIGNER;
    }
);

export const _isTrialWasStarted = (userData) => {
    return userData.trial_started_at && userData.trial_started_at !== null  ? true : false
}

export const _isSubscriptionAccessible = (userData) => {
    if (!userData || !userData.subscription_status) {
        return false;
    }

    return _isSubscriptionActive(userData) || _isSubscriptionUnpaid(userData) || _isSubscriptionPastDue(userData) || _isSubscriptionIncomplete(userData);
}
export const _isSubscriptionActive = (userData) => {
    if (!userData || !userData.subscription_status) {
        return false;
    }

    return [subscriptionStatus.STATUS_ACTIVE, subscriptionStatus.STATUS_TRIALING].includes(userData.subscription_status);
}
const _isSubscriptionIncomplete = (userData) => {
    if (!userData || !userData.subscription_status) {
        return false;
    }

    return userData.subscription_status == subscriptionStatus.STATUS_INCOMPLETE || userData.subscription_status == subscriptionStatus.STATUS_INCOMPLETE_EXPIRED;
}
const _isSubscriptionUnpaid = (userData) => {
    if (!userData || !userData.subscription_status) {
        return false;
    }

    return userData.subscription_status == subscriptionStatus.STATUS_UNPAID;
}
const _isSubscriptionPastDue = (userData) => {
    if (!userData || !userData.subscription_status) {
        return false;
    }

    return userData.subscription_status == subscriptionStatus.STATUS_PAST_DUE;
}